import { type ElementOrNested, getAllElements } from '../../../shared/domain/flows/element.no-deps'
import { I18N_replaceSlug } from '../I18N/I18N.slugs'
import type { NProcessFlow } from '../PF/PF.types'
import type { Type_IUnit } from '../Type/Type.hive'
import { flatMap, uniq, compact } from 'lodash'
import { compose } from '../../../shared/lib/functional/compose.no-deps'
import { fakeFetchUrl } from '../../../app-core/lib/file/withS3Url'
import { Cust_canCacheFlowImages } from '../Cust/Cust.serverPrefs'
import { Imag_cacheImages } from './Imag.cache'
import type { AppFlowWorkflow } from '../../../shared/domain/workflows/types.no-deps'

export function Imag_getImageUrlsForUnits(units: Type_IUnit[]) {
    if (!units) return []

    return units.map((unit) => unit.data.image).filter((url) => url !== undefined)
}

export function Imag_getImageUrlsForPf(processFlows: NProcessFlow.IProcessFlowV2[]) {
    if (!processFlows) return []

    const imageUrls: string[] = []

    processFlows.forEach((pf) => {
        pf.questions.forEach((question) => {
            if (question.type === 'display-image') {
                question.options.sources.forEach((source) => imageUrls.push(I18N_replaceSlug(source.url)))
            }
        })
    })

    return imageUrls
}

function extractImageUrls(elements: ElementOrNested[]) {
    return compact(
        flatMap(elements, (element) => {
            if (element.type === 'image-content') return [element.url, fakeFetchUrl(element.annotationFileId)]
            if (element.type === 'image-select') {
                return flatMap(element.choices, (choice) => [choice.url, fakeFetchUrl(choice.annotationFileId)])
            }
        })
    )
}

export function Imag_preCacheFlowImages(workflows: AppFlowWorkflow[]) {
    if (!Cust_canCacheFlowImages()) return
    if (!workflows) return
    const flows = workflows.filter((w) => !w.isDeleted).map(({ flow }) => flow)
    const imgUrls = flatMap(flows, compose(getAllElements, extractImageUrls))
    return Imag_cacheImages(uniq(imgUrls))
}

export function Imag_isImageUrlPointingToLocalContent(url: string) {
    // Check if url of the image is pointing to shared/images which are stored locally
    return url.startsWith('shared/images')
}
